<template>
  <div style="margin-top: 10px">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center">{{Title}}</h2>
        <base-input type="number" v-model="dataModel.CBU" :maxLength="this.MaxLength" :placeholder="placeholderInput" @blur="change"></base-input>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script>
export default {
  props: {
    Title: {
      type: String,
      default: "",
      description: "",
    },
    MissingItemEntityID: {
      type: Number,
      default: 0,
      description: "",
    },
    MaxLength: {
        type: Number,
        default: 22,
        description: ""
    }
  },
  data() {
    return {
      dataModel: { CBU: "" },
      Validate: true,
      JSONValue: "",
      Errors: [],
      placeholderInput: "22 digitos numericos, sin espacios ni guiones"
    };
  },
  methods: {
    change(element) {
      this.validate();
      this.JSONValue = JSON.stringify(this.dataModel);
      this.$emit("saveValue", {
        MissingItemEntityID: this.MissingItemEntityID,
        JSON: this.JSONValue,
      });
    },
    validate() {
      var _context = this;
      _context.Errors = [];

      if (_context.dataModel.CBU.length == 0 || _context.dataModel.CBU.length < 22) {
        _context.Errors.push("Debe ingresar un valor valido de CBU");
      }
      _context.emitErrors(_context);
    },
    emitErrors(_context) {
      this.$emit("setErrors", _context.Errors);
    },
  },
};
</script>